<div class="content" *ngIf="request">
    <h4 class="row">Информация за заявка</h4>
    <igx-card>
        <igx-list>
            <div class="row">
                <igx-list-item>Дете: {{request.kidName}}</igx-list-item>
                <igx-list-item>Дата на раждане: {{request.kidBirth | date:"yyyy-MM-dd" }}</igx-list-item>
                <igx-list-item>Възраст: {{calculateAge(request.kidBirth)}}</igx-list-item>
                <igx-list-item>Спорт: {{sport}}</igx-list-item>
                <igx-list-item>Ниво: {{level}}</igx-list-item>
            </div>
            <div class="row">
                <igx-list-item>Програма: {{program}}</igx-list-item>
                @if(request.product) {
                    <igx-list-item>Продукт: {{request.product}}</igx-list-item>
                }
                <igx-list-item>Начало: {{renderDates(request.dates)}}</igx-list-item>
                @if(busStop){
                <igx-list-item>Спирка: {{busStop.busStop.name}} - {{busStop.busStop.description}}</igx-list-item>
                <igx-list-item>Час на тръгване: {{renderHours(busStop.timeMorning!.toString())}}</igx-list-item>
                <igx-list-item>Час на връщане: {{renderHours(busStop.timeEvening!.toString())}}</igx-list-item>
                }
            </div>
            <div class="row">
                <igx-list-item>Родител: {{request.parentName}}</igx-list-item>
                <igx-list-item>Телефон: {{request.parentPhone}}</igx-list-item>
                <igx-list-item>Email: {{request.parentEmail}}</igx-list-item>
            </div>
            <div class="row">
                <igx-list-item>Втори родител: {{request.secondParentName}}</igx-list-item>
                <igx-list-item>Телефон: {{request.secondParentPhone}}</igx-list-item>
            </div>
            <div class="row">
                <igx-list-item>Бележки: {{request.notes ?? 'Няма'}}</igx-list-item>
            </div>
        </igx-list>
    </igx-card>
</div>